import { useState } from 'react';
import { trU } from '../../lib/i18n';
import { C } from '../../theme/palette';

export const SaveBar = ({ label, color }) => {
  const [ok, setOk] = useState(false);
  return (
    <button
      onClick={() => {
        setOk(true);
        setTimeout(() => setOk(false), 2000);
      }}
      style={{
        width: '100%',
        marginTop: 12,
        marginBottom: 4,
        background: ok ? C.green : color || C.navy,
        color: '#fff',
        border: 'none',
        borderRadius: 10,
        padding: '13px',
        fontSize: 12,
        fontWeight: 800,
        cursor: 'pointer',
      }}
    >
      {ok ? trU('✓ Enregistré !') : trU(label || '✓ Enregistrer')}
    </button>
  );
};
